<template>
    <div id="app">
        <pageHeader/>
        <router-view></router-view>
        <SystemStop v-if="$root.showSystemStop" :systemInfo="$root.systemInfo" @close="$root.showSystemStop = false"/>
    </div>
</template>
<script>

import pageHeader from "@/components/PageHeader/index.vue";
import SystemStop from "@/components/SystemStop/index.vue";

var win = window;
export default {
    components: {pageHeader, SystemStop},
    data() {
        return {}
    },
    name: 'app',
    mounted() {
         this.resizePage(1920)
         console.log('App.vue mounted, $root.showSystemStop:', this.$root.showSystemStop);
         console.log('App.vue mounted, $root.systemInfo:', this.$root.systemInfo);
    },
    methods: {
        resizePage: function (baseWidth) {
            var baseW = baseWidth || 750;
            var docEl = document.documentElement,
                resizeEvt = 'orientationchange' in win ? 'orientationchange' : 'resize',
                recalc = function () {
                    var clientWidth = docEl.clientWidth;
                    if (!clientWidth) {
                        return;
                    }
                    if (clientWidth <= 1199) {
                        docEl.style.fontSize = '60px';
                    } else {
                        docEl.style.fontSize = 110 * (clientWidth / baseW) + 'px';
                    }
                    // if (clientWidth > baseW) {
                    //     docEl.style.fontSize = '100px';
                    // }

                };
            if (!document.addEventListener) {
                return;
            }
            win.addEventListener(resizeEvt, recalc, false);
            recalc();
        },
    },
    watch: {
        '$root.showSystemStop': function(newVal, oldVal) {
            console.log('showSystemStop changed from', oldVal, 'to', newVal);
        }
    }
}
</script>
<style lang="scss">
/*-----------------[初始化]--------------*/
*, *:before, *:after {
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
}

html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
}

article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
}

ol, ul {
    list-style: none;
}

blockquote, q {
    quotes: none;
}

blockquote:before, blockquote:after, q:before, q:after {
    content: "";
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

body {
    color: #3d4c63;
    background: #fff;
    font: 14px/1.5 "Microsoft Yahei", sans-serif;
    outline: 0;
}

a {
    color: #333;
    text-decoration: none;
}

a:hover {
    color: inherit;
}

img {
    max-width: 100%;
    border: none;
}

em, i {
    font-style: normal;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

input, textarea, select {
    font-size: 12px;
    color: #444;
    font-family: "Microsoft Yahei", sans-serif;
    outline: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
}

input[type="submit"], input[type="reset"], input[type="button"], select, button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

input[type="submit"], input[type="reset"], input[type="button"], button {
    cursor: pointer;
}

.false:focus {
    border: 2px solid #ff1531;
    background: #fff;
}

::-webkit-input-placeholder {
    color: #999;
}

::-moz-placeholder {
    color: #999;
}

:-ms-input-placeholder {
    color: #999;
}

/* 去掉 IE10+ 密码框默认小眼睛、输入框 X */
::-ms-clear, ::-ms-reveal {
    display: none;
}


</style>
